import {Component} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {triggerDetailPopup} from "../../defines/client.const";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";


export interface StatusCommonPopups {
  readonly showMsg: boolean;
  readonly showYoutube: boolean;
  readonly showNaverLogin: boolean;
}

@Component({
  selector: 'app-common-popups',
  template: `
    <app-msg-popup *ngIf="status.showMsg && lm.mpConfig"
                   [config]="lm.mpConfig"></app-msg-popup>

    <app-youtube-player *ngIf="status.showYoutube && lm.youtubeId"
                        [youtubeId]="lm.youtubeId"></app-youtube-player>

    <app-naver-login-popup *ngIf="status.showNaverLogin"></app-naver-login-popup>
  `,
  animations: [
    triggerDetailPopup,
    trigger('BookmarkInOut', [
      transition(':enter', [
        style({transform: 'translateY(100%)'}),
        animate('150ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({transform: 'translateY(50%)'}))
      ])
    ]),
    trigger('PitchInOut', [
      transition(':enter', [
        style({transform: 'translateY(100%)'}),
        animate('150ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({transform: 'translateY(50%)'}))
      ])
    ]),
  ],
})
export class CommonPopupsComponent {

  protected readonly status: StatusCommonPopups;

  constructor(
    protected lm: LayoutMgrService,
  ) {
    this.status = lm;
  }
}
